module.exports = __webpack_public_path__ + "img/zeebu.a7796af0.png";